import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  coursewareActivityList: [],
  loading: false,
}

const scoringSlice = createSlice({
  name: 'scoring',
  initialState,
  reducers: {
    setCoursewareActivityList(state, action) {
      state.coursewareActivityList = action.payload
    },
    setLoading(state, action) {
      state.loading = action.payload
    },
    resetCoursewareActivityList(state) {
        state.coursewareActivityList = initialState.coursewareActivityList,
        state.loading = initialState.loading
    }
  }
})

export const {
  setCoursewareActivityList,
  setLoading,
} = scoringSlice.actions;

export default scoringSlice.reducer;
